export default __webpack_public_path__ + "static/media/carousel_2_1.f984c264.jpg";